import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { UserRoleEnum } from '@app/types';

import { ProcessCatalogRouter } from '../../../process-catalog/types';
import { modules } from '../../modules';

@injectable()
export class ProcessCatalogRouterService implements ProcessCatalogRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDetail(id: string, role?: UserRoleEnum) {
    this.history.push(
      `/${role ?? this.role.get()}/${modules.events.basename}/${id}`,
    );
  }

  goToList() {
    this.history.push({
      pathname: `/${modules.process_catalog.basename}`,
    });
  }
  goToCreate(query: string) {
    this.history.push({
      pathname: `/${this.role.get()}/${modules.events.basename}/create`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreateBatch({
    companyId,
    eventTypeId,
    employeeId,
    parentEventId,
    role,
  }: {
    companyId: string;
    eventTypeId: string;
    employeeId?: string;
    parentEventId?: string;
    role?: UserRoleEnum;
  }) {
    let searchString = `?companyId=${companyId}&eventTypeId=${eventTypeId}`;

    if (employeeId) {
      searchString += `&employeeId=${employeeId}`;
    }

    if (parentEventId) {
      searchString += `&parentEventId=${parentEventId}`;
    }

    this.history.push({
      pathname: `/${role ?? this.role.get()}/${modules.events.basename}/create-batch`,
      search: searchString,
    });
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }
}
